var orderStateFilter = function(Order) {
  return function(order) {
    if (!order) { return ''; }
    return Order.orderStatus(order)
  };
};
orderStateFilter.$inject = ['Order'];
tiz.filter('orderState', orderStateFilter);

var orderStateWithoutTimeFilter = function(Order) {
  return function(order) { return Order.orderStatus(order, { without_time: true }) };
};
orderStateWithoutTimeFilter.$inject = ['Order'];
tiz.filter('orderStateWithoutTime', orderStateWithoutTimeFilter);

var orderStateWithoutTimeForRetailerFilter = function(orderStateWithoutTimeFilter) {
  return function(order) {
    if (order.state == 'pending_rejection') {
      return 'Pending';
    } else {
      return orderStateWithoutTimeFilter(order);
    };
  };
};
orderStateWithoutTimeForRetailerFilter.$inject = ['orderStateWithoutTimeFilter'];
tiz.filter('orderStateWithoutTimeForRetailer', orderStateWithoutTimeFilter);

var orderInStockProductsRatioFilter = function() {
  return function(order) {
    return `(${order.in_stock_count} / ${order.product_count} products)`;
  };
};
orderInStockProductsRatioFilter.$inject = [];
tiz.filter('orderInStockProductsRatio', orderInStockProductsRatioFilter);
